import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Lien partenaire public (/p/marie-instagram) : compte le clic de façon anonyme,
// mémorise la provenance pour l'inscription, puis redirige vers la destination prévue.
export default function PartnerLink() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    let visitorId = localStorage.getItem("rav-visitor-id");
    if (!visitorId) {
      visitorId = `v-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem("rav-visitor-id", visitorId);
    }
    axios
      .post(`${API}/partners/track`, { slug, visitor_id: visitorId })
      .then(({ data }) => {
        localStorage.setItem("rav-partner", JSON.stringify({ link_id: data.link_id, ts: data.ts }));
        const dest = data.destination || "/";
        // La page de marque (logo + slogan RAV) reste visible un instant avant la redirection
        setTimeout(() => {
          if (/^https?:\/\//i.test(dest)) window.location.href = dest;
          else navigate(dest, { replace: true });
        }, 1400);
      })
      .catch((err) => setError(err.response?.data?.detail || "Ce lien partenaire n'est pas disponible."));
  }, [slug, navigate]);

  return (
    <main className="rav-page" data-testid="partner-link-page" style={{ textAlign: "center" }}>
      <img src="/logo-accueil.webp" alt="Respire Aime Vibre" className="rav-page-logo" />
      <p className="rav-page-sub" data-testid="partner-link-slogan" style={{ textAlign: "center", fontStyle: "italic" }}>
        L'Instant qui vous ressemble
      </p>
      {error ? (
        <>
          <p className="rav-page-sub" data-testid="partner-link-error">{error}</p>
          <button type="button" className="rav-primary-button" data-testid="partner-link-home" onClick={() => navigate("/")}>
            Découvrir Respire Aime Vibre
          </button>
        </>
      ) : (
        <p className="rav-page-sub" data-testid="partner-link-loading">Bienvenue chez Respire Aime Vibre…</p>
      )}
    </main>
  );
}
